import { useEffect, useRef, useState } from "react";
import styles from "./leasesign.module.css";
import { Helmet } from "react-helmet";
import Loader from "../../../components/Loader";
import { Background, Parallax } from 'react-parallax';
import { Link as Linkto, useHistory } from "react-router-dom";
import SignaturePad from "react-signature-canvas";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ArrowLeft, X } from "react-feather";
import axios from "axios";
import dayjs from "dayjs";
import OTPInput from "react-otp-input";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import NumberFormat from "react-number-format";

function PhoneField(props) {
    return <NumberFormat prefix="" displayType="input" type="text" format={"(###) ###-####"}    {...props} />;
}

const phoneRegExp = /^\(?([0-9]{3})\)?[ ]?([0-9]{3})[-]?([0-9]{4})$/;
const loginSchema1 = yup.object().shape({
    phone: yup.string().required('This field is Required').matches(phoneRegExp, 'Invalid phone number')
});

const loginSchema2 = yup.object().shape({
    otp: yup.string().required('Please enter 6 digit code.').min(6, 'Please enter 6 digit code.').max(6, 'Please enter 6 digit code.')
});

const LeaseSign = ({ history, match }) => {
    const { str } = match.params;
    const redirect = useHistory();
    const [loading, setLoading] = useState(true);
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [leaseDetails, setLeaseDetails] = useState(null);
    const [teanntDetails, setTenantDetails] = useState(null);
    const [leaseDocumentData, setLeaseDocumentData] = useState(null);
    const [sigDialogOpen, setSigDialogOpen] = useState(false);
    const [signaureImage, setSignaureImage] = useState('');
    const [leaseDocumentDataNew, setSignaureImageNew] = useState(null);

    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [loginModalOpen2, setLoginModalOpen2] = useState(false);
    const [loginError, setLoginError] = useState('');
    const [loginError2, setLoginError2] = useState('');
    const [loginPhone, setLoginPhone] = useState('');
    const [resendSuccess, setResendSuccess] = useState('');

    const { register: loginRegister1, handleSubmit: loginHandleSubmit1, control: loginControl1, errors: loginErrors1 } = useForm({
        resolver: yupResolver(loginSchema1),
        mode: 'onSubmit',
        reValidateMode: 'onChange',
    });

    const { register: loginRegister2, handleSubmit: loginHandleSubmit2, control: loginControl2, errors: loginErrors2, clearErrors, setValue } = useForm({
        resolver: yupResolver(loginSchema2)
    });

    let sigCanvas = useRef(null);

    useEffect(() => {
        let TenantRenewLeaseLoginData = localStorage.getItem("TenantRenewLeaseLoginData");
        if (TenantRenewLeaseLoginData) {
            TenantRenewLeaseLoginData = JSON.parse(TenantRenewLeaseLoginData);
            let timeDef = Date.now() - TenantRenewLeaseLoginData?.time;
            timeDef = Math.floor(timeDef / 1000 / 60 / 60);

            if (timeDef < 1) {
                setTenantDetails(TenantRenewLeaseLoginData?.tenantData);
                setLoginModalOpen(false);
            } else {
                setLoading(false);
                setLoginModalOpen(true);
            }
        } else {
            setLoading(false);
            setLoginModalOpen(true);
        }
    }, [setLoginModalOpen]);

    useEffect(() => {
        const fetchTemplates = async () => {
            setLoading(true);
            let tenantInfoId = 0;
            if (teanntDetails) {
                tenantInfoId = teanntDetails?.id;
            }
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/lease-data/" + tenantInfoId + "/" + str).then((response) => {
                setLoading(false);

                setPropertyDetails(response.data.propertyData);
                setLeaseDetails(response.data.leaseData);
                setLeaseDocumentData(response.data.data);
            }).catch((error) => {
                redirect.push('/rental-application-invalid');

                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 0);
            });
        }
        if (str)
            fetchTemplates();
    }, [str, teanntDetails]);

    const formatIntoPng = () => {
        if (sigCanvas.current) {
            const dataURL = sigCanvas.current.toDataURL();
            setSignaureImage(dataURL);
            return dataURL;
        }
    }

    useEffect(() => {
        if (signaureImage) {
            let leaseDocumentDataTemp = leaseDocumentData?.map(i => {
                let htmlNew = i?.description;
                htmlNew = htmlNew.replace("../../static/tenant-1-signature.jpg", signaureImage);

                return { ...i, description: htmlNew };
            });
            setSignaureImageNew(leaseDocumentDataTemp);
        } else {
            setSignaureImageNew(leaseDocumentData);
        }
    }, [signaureImage, leaseDocumentData]);

    const saveSign = () => {
        setLoading(true);
        axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/save-lease", { lease_id: leaseDetails?.id, signature: signaureImage, tenant_info_id: teanntDetails?.id }).then((response) => {
            setLoading(false);

            redirect.push('/lease-sign-success/' + response?.data?.data);

            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
        }).catch((error) => {
            setLoading(false);
        });
    }

    const getToken = (data) => {
        setLoginError('');
        setLoginError2('');
        setLoginPhone('');
        setLoading(true);
        setResendSuccess('');

        data = { ...data, tenantId: leaseDetails?.tenant_id };

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/send-login-code', data).then(response => {
            setLoading(false);
            if (response.data.status === 'validation-error') {
                setLoginError(response.data.message);
                return false;
            }
            if (response.data?.resp?.error && response.data?.resp?.error === 'bad.connection') {
                setLoginError('The phone number is invalid.');
                return false;
            }
            if (response.data?.resp?.error) {
                setLoginError(response.data?.resp?.error_description);
                return false;
            }
            if (!response.data?.resp?.error) {
                setLoginModalOpen(false);
                setLoginModalOpen2(true);
                setLoginPhone(response.data?.resp?.phone_number);
            }
        }).catch((error) => {
            setLoading(false);
            setLoginError(error?.response.data.message);
            return false;
        });
    }

    const confirmToken = (data) => {
        setResendSuccess('');
        setLoading(true);
        setLoginError2('');

        data = { ...data, phone: loginPhone };

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/authenticate-code', data).then(response => {
            setLoading(false);
            if (!response?.data?.status) {
                setLoginError2(response?.data?.message);
                return false;
            } else {
                setTenantDetails(response?.data?.data);
                localStorage.setItem("TenantRenewLeaseLoginData", JSON.stringify({ tenantData: response?.data?.data, time: Date.now() + (24 * 60 * 60 * 1000) }));
                setLoginModalOpen2(false);
            }
        }).catch((error) => {
            setLoading(false);
        });
    }

    const resendCode = () => {
        setLoading(true);

        let data = { phone: loginPhone.replace('+1', ''), tenantId: leaseDetails?.tenant_id };

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/send-login-code', data).then(response => {
            setLoading(false);
            setResendSuccess('Verification token has been resent.');
        }).catch((error) => {
            setLoading(false);
        });
    }

    return (<>
        {loading && <Loader />}
        <Helmet title="Sign Your Lease" />
        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
                <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>

        <div className="WhiteBG">
            <div className={`${styles.RentalAppliArea}`}>

                <div className={`${styles.RentalAppliHead}`}>
                    <img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" style={{ width: '200px' }} />
                    <p className={`${styles.RentalAppliHeadTitle}`}>{propertyDetails?.name}</p>
                </div>

                <div className={`${styles.ApplicantSec}`}>
                    <p className={`${styles.ApplicantSecTitle}`}>Lease Sign</p>
                    <div className={`${styles.TemplateMainConSec}`}>

                        {leaseDocumentDataNew?.map((item) => {
                            return (<div style={{ borderBottom: '1px solid #e5e8eb', margin: '30px 0', padding: '15px 0' }}>
                                <div dangerouslySetInnerHTML={{ __html: item?.description }} />
                            </div>);
                        })}

                        <div className={`${styles.LeaseBUSec}`}>
                            <button type="button" onClick={(e) => {
                                setSigDialogOpen(true);

                                if (signaureImage) {
                                    setTimeout(() => {
                                        sigCanvas.current.fromDataURL(signaureImage);
                                    }, 500);
                                }

                            }} className={`${styles.RentallAppliSignBU} ${styles.Active}`}>Sign Lease <img src="/static/img/Icon-send.png" alt="" /></button>
                            <button type="button" onClick={(e) => saveSign()} className={`${styles.RentallAppliSubmitBU}`} disabled={signaureImage === ''}>Submit</button>
                        </div>

                    </div>
                </div>

            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: ${propertyDetails?.email}`}>{propertyDetails?.email}</a></li>
                                <li><a href={`tel: ${propertyDetails?.phone}`} >{propertyDetails?.phone}</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>{propertyDetails?.address} <br />{propertyDetails?.city}, {propertyDetails?.state} {propertyDetails?.zip}</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

            <Dialog
                className="NewPopUp"
                fullwidth
                maxWidth="sm"
                open={sigDialogOpen}
                onClose={(e) => setSigDialogOpen(false)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    <span>Add your signature</span>
                    <button edge="start" color="inherit" onClick={(e) => setSigDialogOpen(false)} aria-label="close">
                        <X />
                    </button>
                </DialogTitle>
                <DialogContent className="SignaturePopupBody">
                    <SignaturePad
                        ref={sigCanvas}
                        onEnd={formatIntoPng}
                        penColor="black"
                        canvasProps={{
                            width: 500,
                            height: 310
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <button onClick={(e) => {
                        setSignaureImage('');
                        if (sigCanvas.current) {
                            sigCanvas.current.clear();
                        }
                    }} className="FileCanBU">Reset</button>
                    <button onClick={(e) => {
                        setSigDialogOpen(false);
                    }} color="primary" className="FileReBU">Insert</button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={loginModalOpen}
                fullWidth
                maxWidth="xs"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp"
            >
                <form onSubmit={loginHandleSubmit1(getToken)}>
                    <DialogTitle id="alert-dialog-title" className={`${styles.OtpPopupTTSec}`}>Welcome to PropertyDek</DialogTitle>
                    <DialogContent>
                        <p className="PopTokenText">Enter your phone number and we'll send a text to verify your phone.</p>

                        <div className="PopTokenFormSec">
                            <img src={'/static/img/USA-icon.svg'} alt="logo" />
                            <p className="FormCodeSec">+1</p>
                            <Controller
                                name="phone"
                                render={({ onChange, value }) => (<PhoneField className="PopTokenInput" value={value} onChange={(e) => { onChange(e); setLoginError(''); }} />)}
                                control={loginControl1}
                                ref={loginRegister1}
                                className="PopTokenInput"
                            />
                        </div>
                        {(loginError !== '') && <p className={`${styles.ErrorM2}`}>{loginError}</p>}
                        {loginErrors1?.phone && <p className={`${styles.ErrorM2}`}>{loginErrors1?.phone.message}</p>}
                    </DialogContent>
                    <DialogActions className={`${styles.ButtonSec}`}>
                        <Button type="submit" className="SubmitPopupBUPopPin">Next</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog
                open={loginModalOpen2}
                fullWidth
                maxWidth="xs"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp"
            >
                <form onSubmit={loginHandleSubmit2(confirmToken)}>
                    <DialogTitle id="alert-dialog-title" className={`${styles.OtpPopupTTSec}`}>Confirm token</DialogTitle>
                    <DialogContent>
                        <p className="PopTokenText">Confirm token by typing in the 6 digit code we sent via text to {loginPhone}.</p>
                        <div className="PinArea">
                            <Controller
                                name="otp"
                                render={({ onChange, value }) => (<OTPInput
                                    value={value}
                                    onChange={(e) => { onChange(e); setResendSuccess(''); clearErrors(); setLoginError2('') }}
                                    numInputs={6}
                                    inputType='number'
                                    renderSeparator={<span>-</span>}
                                    renderInput={(props) => <input {...props} />}
                                />)}
                                control={loginControl2}
                                ref={loginRegister2}
                            />
                            {loginErrors2?.otp && <p className={`${styles.ErrorM2}`}>{loginErrors2?.otp.message}</p>}
                            {(loginError2 !== '') && <p className={`${styles.ErrorM2}`}>{loginError2}</p>}
                            {/* <p className="PopTokenTText">We sent a code to the following phone number:</p> */}
                            {resendSuccess !== '' && <p className="PopTokenTText">{resendSuccess}</p>}
                            <div className="Poplink">
                                {/* <button className="PopTokenLink">{loginPhone}</button> */}
                                <button className="PopTokenLink" type='button' onClick={(e) => { setResendSuccess(''); resendCode(); setLoginError2(''); setValue('otp', ''); clearErrors(); }}>Resend code</button>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className={`${styles.ButtonSec}`}>
                        <Button type="submit" className="CancelPopupBUPin" onClick={(e) => { setLoginError(''); setLoginError2(''); setLoginModalOpen2(false); setLoginModalOpen(true); }}><ArrowLeft /></Button>
                        <Button type="submit" className="SubmitPopupBUPopPin">Confirm</Button>
                    </DialogActions>
                </form>
            </Dialog>

        </div >

    </>)
}

export default LeaseSign;